<script>
import { Bar, mixins } from "vue-chartjs";
const { reactiveProp } = mixins;

export default {
  extends: Bar,
  mixins: [reactiveProp],
  props: {
    chartData: Object,
  },
  data() {
    return {
      options: {
        hover: { mode: null },
        tooltips: {
          enabled: false,
        },
        layout: {
          padding: {
            top: 0,
            bottom: 0,
          },
        },
        scales: {
          yAxes: [
            {
              display: true,
              ticks: {
                min: -1,
                max: 1,
                maxTicksLimit: 3,
                fontColor: "white",
                fontStyle: "bold",
                fontSize: 14,
                callback: function(value, index, values) {
                  switch (index) {
                    case 0:
                      return "Highest score   ";
                      break;
                    case 1:
                      return "Average   ";
                      break;
                    case 2:
                      return "Lowest score   ";
                      break;
                  }
                },
              },
              gridLines: {
                color: "white",
                display: true,
                zeroLineColor: "#fff",
                zeroLineWidth: 1,
                zeroLineBorderDash: [10, 10],
                drawBorder: false,
              },
            },
          ],
          xAxes: [
            {
              gridLines: {
                display: false,
                drawBorder: false,
              },
              barPercentage: 0.5,
              display: true,
              ticks: {
                fontColor: "white",
                fontSize: 14,
                padding: 0,
                stepSize: 6,
                unitStepSize: 5,
              },
            },
          ],
        },
        legend: {
          display: false,
        },
        responsive: true,
        maintainAspectRatio: false,
      },
    };
  },
  mounted() {
    this.renderChart(this.chartData, this.options);
  },
};
</script>
